export default __webpack_public_path__ + "static/media/EL1.c7f810da.png";